import(/* webpackMode: "eager", webpackExports: ["TourSearchResults"] */ "/codebuild/output/src4105622566/src/faunaexplore-frontend/src/app/search/components/TourSearchResults.tsx");
